import React from 'react';

const LabelSubItem = ({ children, className = '' }) => (
  <span className={`text-sm font-light static ml-5 whitespace-nowrap ${className}`}>{children}</span>
);

export default LabelSubItem;
